import { render } from "./languageVerify.vue?vue&type=template&id=f18bcf9c"
import script from "./languageVerify.vue?vue&type=script&lang=js"
export * from "./languageVerify.vue?vue&type=script&lang=js"

import "./languageVerify.vue?vue&type=style&index=0&id=f18bcf9c&lang=less"

import exportComponent from "D:\\project\\Mase_Customer\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__